import { render } from "./top10.vue?vue&type=template&id=ce04dadc&scoped=true&ts=true"
import script from "./top10.vue?vue&type=script&lang=ts"
export * from "./top10.vue?vue&type=script&lang=ts"

import "./top10.vue?vue&type=style&index=0&id=ce04dadc&lang=less"
import "./top10.vue?vue&type=style&index=1&id=ce04dadc&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce04dadc"]])

export default __exports__